import { AutoLinkFormData } from '../components/process-definitions/process-definitions-form/auto-link/models/auto-link-form-data';
import { ICopyable } from '../controls/common/icopyable';
import { CriteriaSearchZone } from './enums/criteria-search-zone';
import { FailedAutoLinkAction } from './enums/failed-auto-link-action';
import { SearchMode } from './enums/search-mode';
import { OverridedAttribute } from './overrided-attribute';
import { SearchOptions } from './search-options';
import { SettingsBase } from './settings-base';

export class AutoLinkSettings extends SettingsBase implements ICopyable<AutoLinkSettings>, AutoLinkFormData {
    public issuer: string = null;
    public customerId: number = null;
    public documentTypeId: number = null;
    public searchExpression: string = null;
    public searchOptions: SearchOptions = new SearchOptions();
    public searchMode: SearchMode = SearchMode.None;
    public criteriaSearchZones: CriteriaSearchZone[] = null;
    public attributeId: number = null;
    public postLinkStateId?: number = null;
    public allowedStateIds: number[] = null;
    public overridedAttributes: OverridedAttribute[] = null;
    public failedAutoLinkAction: FailedAutoLinkAction;

    public createCopy(): AutoLinkSettings {
        const instance = new AutoLinkSettings();
        instance.issuer = this.issuer;
        instance.customerId = this.customerId;
        instance.documentTypeId = this.documentTypeId;
        instance.searchExpression = this.searchExpression;
        instance.searchOptions = this.searchOptions;
        instance.searchMode = this.searchMode;
        if (this.criteriaSearchZones) {
            instance.criteriaSearchZones = [...this.criteriaSearchZones];
        }
        instance.type = this.type;
        instance.attributeId = this.attributeId;
        instance.postLinkStateId = this.postLinkStateId;
        if (this.allowedStateIds) {
            instance.allowedStateIds = [...this.allowedStateIds];
        }

        if (this.overridedAttributes) {
            instance.overridedAttributes = JSON.parse(JSON.stringify(this.overridedAttributes)); // Deep clone
        }
        instance.failedAutoLinkAction = this.failedAutoLinkAction;

        return instance;
    }

    public static createFrom(other: any): AutoLinkSettings {
        const instance = new AutoLinkSettings();
        instance.issuer = other.issuer;
        instance.customerId = other.customerId;
        instance.documentTypeId = other.documentTypeId;
        instance.searchExpression = other.searchExpression;
        instance.searchOptions = other.searchOptions;
        instance.searchMode = other.searchMode;
        if (other.criteriaSearchZones) {
            instance.criteriaSearchZones = [...other.criteriaSearchZones];
        }
        instance.type = other.type;
        instance.attributeId = other.attributeId;
        instance.postLinkStateId = other.postLinkStateId;
        if (other.allowedStateIds) {
            instance.allowedStateIds = [...other.allowedStateIds];
        }
        if (other.overridedAttributes) {
            instance.overridedAttributes = JSON.parse(JSON.stringify(other.overridedAttributes)); // Deep clone
        }
        instance.failedAutoLinkAction = other.failedAutoLinkAction;

        return instance;
    }

    public copyFrom(other: any) {
        this.issuer = other.issuer;
        this.customerId = other.customerId;
        this.documentTypeId = other.documentTypeId;
        this.searchExpression = other.searchExpression;
        this.searchOptions = other.searchOptions;
        this.searchMode = other.searchMode;
        if (other.criteriaSearchZones) {
            this.criteriaSearchZones = [...other.criteriaSearchZones];
        }
        this.type = other.type;
        this.attributeId = other.attributeId;
        this.postLinkStateId = other.postLinkStateId;
        if (other.allowedStateIds) {
            this.allowedStateIds = [...other.allowedStateIds];
        }
        if (other.overridedAttributes) {
            this.overridedAttributes = JSON.parse(JSON.stringify(other.overridedAttributes)); // Deep clone
        }
        this.failedAutoLinkAction = other.failedAutoLinkAction;
    }
}
